import script from "./register.vue?vue&type=script&setup=true&lang=js"
export * from "./register.vue?vue&type=script&setup=true&lang=js"

import "./register.vue?vue&type=style&index=0&id=54b7101e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54b7101e"]])

export default __exports__